import { render, staticRenderFns } from "./loanOrderDetail.vue?vue&type=template&id=aaf96fa0&scoped=true&"
import script from "./loanOrderDetail.vue?vue&type=script&lang=js&"
export * from "./loanOrderDetail.vue?vue&type=script&lang=js&"
import style0 from "./loanOrderDetail.vue?vue&type=style&index=0&id=aaf96fa0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaf96fa0",
  null
  
)

export default component.exports